import moment from 'moment'
import { resolveActionsData } from './resolveAnnouncementActions'

const CONTENT_FIELDS = [
    'title',
    'caption',
    'moreInfoText',
    'bodyText',
    'conversionButtonText',
    'conversionMessage',
    'emailTemplate',
]

function toInstant(value) {
    return value == null || value === ''
        ? null
        : moment(value).toISOString()
}

// Strapi rejects unknown keys, and the server refuses content on a locked announcement.
export function resolveAnnouncementData(values) {
    const content = CONTENT_FIELDS.reduce((fields, field) => {
        fields[field] = values[field] ?? ''
        return fields
    }, {})

    return {
        name: values.name,
        notes: values.notes ?? '',
        ...(values.isContentLocked ? {} : content),
        // Sent whether or not the content is locked: the names remain editable, and the
        // server accepts a configuration equal to the one it already holds.
        actions: resolveActionsData(values),
        frequency: values.frequency ?? 'oncePerUser',
        startAt: toInstant(values.startAt),
        endAt: toInstant(values.endAt),
    }
}
